module.exports = __webpack_public_path__ + "img/e-commerce.12285819.png";